<script setup lang="ts">
  import { computed } from 'vue';

  import { BvTimer } from '@bv/components';
  import { type Call } from '@bv/stores';
  import { trans } from '@bv/utils';

  const props = withDefaults(
    defineProps<{
      activeCall: Call;
      call?: Call;
      showExpand?: boolean;
      hideIntersectionActions?: boolean;
    }>(),
    {
      call: undefined,
      showExpand: false,
      hideIntersectionActions: false,
    },
  );

  const callDetails = computed<Call | undefined>(() => {
    if (props.hideIntersectionActions && props.activeCall.status === 'ringing') {
      return undefined;
    }
    return props.call;
  });
</script>

<template>
  <div class="flex min-h-7 gap-3">
    <div
      class="flex grow text-xs leading-3"
      :class="{ 'expandable-header': showExpand }"
    >
      <div
        v-if="callDetails"
        class="flex grow"
      >
        <div class="flex grow flex-col gap-1">
          <div class="font-bold text-white">
            {{ callDetails.caller.name || callDetails.caller.number }}
          </div>
          <div class="text-gray-200">
            {{ callDetails.caller.name ? callDetails.caller.number : '' }}
          </div>
        </div>
        <div class="text-end text-[0.625rem] text-green-500">
          <bv-timer :start-time="callDetails.cdr.startTimeAnswer" />
          <div
            v-if="callDetails.isHold"
            class="text-warning-500"
          >
            {{ trans('voip.calls.status.on_hold_trans') }}
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
